"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatUpdateAcknowledgementStatusObservable = void 0;
const socket_1 = require("../../socket");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatUpdateAcknowledgementStatusObservable {
    constructor(chatsStorage, organizationUser) {
        this.chatsStorage = chatsStorage;
        this.organizationId = organizationUser.getOrganization().organizationId;
    }
    updateChatAcknowledgementStatusListener(cb, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(socket_1.DomainEvents.NO_PENDING_ACKNOWLEDGEMENT, this.organizationId), (data) => {
            this.updateAcknowledgementStatus(data.from, false, cb, groupType);
        });
    }
    addAcknowledgementStatusToChatListener(cb, groupType, orgId) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getEventKey)(socket_1.DomainEvents.NEW_ACKNOWLEDGE_ALERT, orgId), (data) => {
            this.updateAcknowledgementStatus(data.from, true, cb, groupType);
        });
    }
    updateAcknowledgementStatus(chatId, ackStatus, cb, groupType) {
        let chatList = this.getChats(groupType);
        if (chatList) {
            let updatedChat = chatList.chats.find(chat => chat.id === chatId);
            if (updatedChat) {
                updatedChat = Object.assign(Object.assign({}, updatedChat), { hasAcknowledgeMessage: ackStatus });
                chatList = Object.assign(Object.assign({}, chatList), { chats: chatList.chats.map(chat => chat.id === chatId ? updatedChat : chat) });
                this.setChats(chatList, groupType);
            }
        }
        cb(chatList);
    }
    getChats(groupType) {
        return this.chatsStorage.getChatListByType(groupType);
    }
    setChats(chatList, groupType) {
        this.chatsStorage.setChatListByType(groupType, chatList);
    }
}
exports.GroupChatUpdateAcknowledgementStatusObservable = GroupChatUpdateAcknowledgementStatusObservable;
